import jwtDecode from 'jwt-decode';
import pick from 'lodash/pick';
import { CustomerAccountType } from 'types/generatedSchemaTypes';
import Logger from 'utils/Logger';

//The token returns more fields, but for security reasons only the used or useful ones are shown, and the more sensitive
// ones are not
export type DecodedAccessTokenType =
  | undefined
  | {
      country: string;
      email: string;
      emails: [string];
      extension_AccountType: string;
      family_name: string;
      given_name: string;
      idp: string;
      isForgotPassword: boolean;
      newUser: boolean;
      sub: string;
    };

export function getCustomerUidFromToken(token: string) {
  try {
    const decoded = jwtDecode<{ sub: string } | undefined>(token);
    return decoded?.sub;
  } catch {
    return null;
  }
}

export function isNewAppUser(
  token: string,
  hasAcceptedTerms: boolean,
  accountType: CustomerAccountType
) {
  try {
    const newAzureUser = jwtDecode<{ newUser: boolean } | undefined>(
      token
    )?.newUser;
    const newUser = newAzureUser ?? accountType === 'NEW';
    const existingUser =
      !newAzureUser && accountType === 'EXISTING_AIMO' && !hasAcceptedTerms;
    return newUser ?? existingUser;
  } catch {
    return false;
  }
}

export function getDecodedToken(token: string) {
  try {
    //Returning "Useful" fields from decoded token, ignoring the ones that could be dangerous to have exposed
    return pick(jwtDecode(token), [
      'country',
      'email',
      'emails',
      'extension_AccountType',
      'family_name',
      'given_name',
      'idp',
      'isForgotPassword',
      'newUser',
      'sub',
    ]);
  } catch {
    Logger.error('Failed to jwt decode token');
    return undefined;
  }
}
